import type { RowSelectionState, Updater } from "@tanstack/react-table"
import type { FC, RefObject } from "react"
import type { CombinedError } from "urql"

import { useApprovedProductColumns } from "../../hooks/useApprovedProductColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { CompanyProductAssociationListItem } from "@/screens/CustomerProducts/stores/useCustomerProductAssociationsStore"

interface ApprovedProductsTableProps {
  data: CompanyProductAssociationListItem[]
  isFetching: boolean
  error?: CombinedError
  rowSelection: RowSelectionState
  cpoProductIds: number[]
  containerRef: RefObject<HTMLDivElement>
  onScroll: () => void
  onSelectionChange: (next: RowSelectionState) => void
}

export const ApprovedProductsTable: FC<ApprovedProductsTableProps> = ({
  data,
  isFetching,
  error,
  rowSelection,
  cpoProductIds,
  containerRef,
  onScroll,
  onSelectionChange,
}) => {
  const columns = useApprovedProductColumns()

  const handleRowSelectionChange = (updaterOrValue: Updater<RowSelectionState>) => {
    const next = typeof updaterOrValue === "function" ? updaterOrValue(rowSelection) : updaterOrValue
    onSelectionChange(next)
  }

  return (
    <AerosBaseTable
      error={error}
      slotProps={{ container: { ref: containerRef, onScroll } }}
      features={{
        table: { stickyHeader: true },
        tanstackOptions: {
          data,
          columns,
          getRowId: (row) => row.productId.toString(),
          state: { rowSelection, isLoading: isFetching },
          onRowSelectionChange: handleRowSelectionChange,
          enableRowSelection: (row) => !cpoProductIds.includes(row.original.productId),
        },
      }}
      noDataMessage='Use the search field to find and select products to add.'
    />
  )
}
